import { render } from "./Navs.vue?vue&type=template&id=25b17f82&scoped=true"
import script from "./Navs.vue?vue&type=script&lang=js"
export * from "./Navs.vue?vue&type=script&lang=js"

import "./Navs.vue?vue&type=style&index=0&id=25b17f82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b17f82"]])

export default __exports__